import posthog from 'posthog-js';

/** @type {Promise<import('posthog-js').PostHog | null> | null} */
let posthogInitPromise = null;
let posthogHeavyEnabled = false;

const POSTHOG_KEY = 'phc_J3PJsLNiXE7G4a6KAbQLgcY88K2c6UsTZxYk2qCOHXt';
const POSTHOG_API_HOST = 'https://us.i.posthog.com';

export const initPosthog = ({ disableFeatureFlagsOnFirstLoad = false } = {}) => {
  if (posthogInitPromise) {
    return posthogInitPromise;
  }

  // Initialize before React can navigate away from the tagged entry URL. The
  // SDK persists acquisition data here; heavy features remain deferred below.
  try {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_API_HOST,
      capture_pageview: 'history_change',
      capture_pageleave: true,
      autocapture: false,
      capture_dead_clicks: false,
      capture_exceptions: false,
      disable_session_recording: true,
      disable_surveys: true,
      advanced_disable_feature_flags_on_first_load: disableFeatureFlagsOnFirstLoad,
    });

    if (typeof window !== 'undefined') {
      posthog.capture('$pageview', {
        $current_url: window.location.href,
        $pathname: window.location.pathname,
      });
    }

    posthogInitPromise = Promise.resolve(posthog);
  } catch {
    posthogInitPromise = Promise.resolve(null);
  }

  return posthogInitPromise;
};

export const enablePosthogHeavyFeatures = () => {
  if (posthogHeavyEnabled) {
    return;
  }

  initPosthog().then((posthog) => {
    if (!posthog || posthogHeavyEnabled) {
      return;
    }

    posthogHeavyEnabled = true;
    posthog.set_config({
      autocapture: true,
      disable_session_recording: false,
      disable_surveys: false,
      advanced_disable_feature_flags_on_first_load: false,
    });

    if (typeof posthog.startExceptionAutocapture === 'function') {
      posthog.startExceptionAutocapture();
    }
    if (typeof posthog.reloadFeatureFlags === 'function') {
      posthog.reloadFeatureFlags();
    }
    if (typeof posthog.startSessionRecording === 'function') {
      posthog.startSessionRecording();
    }
  });
};

export const capturePosthogEvent = (event, properties = {}) => {
  initPosthog().then((posthog) => {
    if (!posthog) {
      return;
    }

    posthog.capture(event, properties);
  });
};
